import styled from 'styled-components';

export const Wrap = styled.header`
    color: #000;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.444;
    order: 1;
    position: relative;
    z-index: 1000;
`;

export const Container = styled.div<HeaderContainerProps>`
    align-items: center;
    background: ${props => props.$backgroundMobile};
    display: flex;
    height: 50px;

    @media (min-width: 992px) {
        background: ${props => props.$background};
        height: 75px;
    }
`;

export const Content = styled.div<HeaderContentProps>`
    align-items: center;
    color: ${props => props.$foreground || 'initial'};
    display: flex;
    height: 100%;
    padding-right: 16px;
    width: 100%;

    @media (min-width: 992px) {
        padding-right: 40px;
    }
`;

export const LogoWrap = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: 992px) {
        padding-left: 40px;
        padding-right: 40px;
    }
`;

export const LogoPicture = styled.picture`
    display: block;
    line-height: 0;
`;

export const LogoMobile = styled.img`
    height: 36px;

    @media (min-width: 992px) {
        display: none;
    }
`;

export const Logo = styled.img`
    display: none;

    @media (min-width: 992px) {
        display: inline;
        height: 50px;
    }
`;

export const PortionMarking = styled.div`
    background-color: #006400;
    color: #ffff00;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 16px;
    line-height: 16px;
    padding: 0 1rem;
    text-align: center;
`;

export const Tagline = styled.p`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
`;

export const Text = styled.a<HeaderTextProps>`
    color: ${props => props.$foreground || '#000'};
    flex: 1;
    text-decoration: none;
    white-space: nowrap;

    @media (min-width: 992px) {
        padding-left: ${props => props.$offset}px;
    }
`;

export const Title = styled.p`
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;
    white-space: nowrap;

    @media (min-width: 992px) {
        font-size: 18px;
    }
`;

export const UserContainer = styled.div`
    margin-left: 16px;
    position: relative;
`;

export const UserActions = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    margin-left: 16px;

    @media (max-width: 576px) {
        gap: 6px;
        margin-left: 8px;
    }
`;

export const UserActionLink = styled.a`
    background: #171716;
    border-radius: 8px;
    border: 2px solid #171716;
    color: #fff;
    display: inline-flex;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    height: 36px;
    line-height: 1;
    min-width: 64px;
    padding: 0 10px;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
`;

export const UserProfile = styled.button`
    align-items: center;
    background: none;
    border: 0;
    display: flex;
    gap: 12px;
`;

export const UserName = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
`;

export const UserPicture = styled.picture`
    border-radius: 50%;
    display: inline-block;
    height: 28px;
    line-height: 1;
    overflow: hidden;
    width: 28px;
`;

export const UserImage = styled.img`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

export const UserProfileMenu = styled.div`
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 5px -3px, rgba(0, 0, 0, 0.14) 0 8px 10px 1px,
        rgba(0, 0, 0, 0.12) 0 3px 14px 2px;
    list-style: none;
    margin: 0;
    padding: 8px 0;
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 1;
`;

export const UserProfileMenuButton = styled.button`
    border: 0;
    background-color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    min-height: 32px;
    padding: 0 24px;
    white-space: nowrap;

    &:active,
    &:focus,
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;

export const UserProfileMenuLink = styled.a`
    border: 0;
    background-color: #fff;
    color: #000;
    display: block;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    min-height: 32px;
    padding: 10px 24px;
    text-decoration: none;
    white-space: nowrap;

    &:active,
    &:focus,
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;
